<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.svg" />
    </vue-element-loading>
    <b-col cols="12" xl="12">
      <transition name="slide">
        <b-card>
          <template slot="header">
            <b-row>
              <b-col cols="12" md="3" class="py-2">
                <span>Inventory</span>
              </b-col>
              <b-col cols="12" md="3" class="py-2">
                <b-button
                  variant="outline-primary"
                  size="sm"
                  router-link
                  to="/Inventory/Add"
                >
                  Add New Item
                </b-button>
              </b-col>
            </b-row>
          </template>
          <b-row>
            <b-col
              v-for="(item, i) in inventory"
              :key="i"
              cols="12"
              sm="12"
              md="6"
              lg="6"
              xl="4"
            >
              <b-card
                @click="$router.push('/Inventory/' + item._id)"
                style="cursor: pointer; max-width: 30rem"
              >
                <b-row>
                  <b-col cols="12" md="4" class="text-center">
                    <b-img
                      :src="baseURL + '/r/' + item.icon"
                      height="70px"
                    ></b-img>
                  </b-col>
                  <b-col cols="12" md="8">
                    <b-row>
                      <b-col cols="12">
                        <span class="item_title">
                          {{ item.name }}
                        </span>
                      </b-col>
                      <b-col cols="12" class="item_value">
                        {{ item.description.slice(0, 110) }}
                        <span v-if="item.description.length > 110"
                          >&nbsp;...</span
                        >
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <span class="item_title">Items - </span>
                    <span class="item_value">{{ item.items.length }}</span>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      inventory: [],
      fields: [
        { key: "name", label: "Name", sortable: false },
        { key: "description", label: "Description", sortable: false },
      ],
      totalData: 0,
      currentPage: 1,
      perPage: 200,
      totalRows: 0,
      appLoading: false,
      ServerError: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    nextPage(ev) {
      this.currentPage = ev;
      this.getData();
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/inventory/shop",
        method: "POST",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        data: {
          shop: localStorage.getItem("shopid"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.inventory = response.data.data;
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    rowClicked(item) {
      this.$router.push("/inventory/" + item._id);
    },
  },
};
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>
